import { render, staticRenderFns } from "./AppShortcut.vue?vue&type=template&id=2a9707d7&"
import script from "./AppShortcut.vue?vue&type=script&lang=js&"
export * from "./AppShortcut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports